import apiAxios from "@/services/axiosConfig";
import type { UnifiedDashboardResponse } from "../types";

export default async function getDashboard(from: string, to: string): Promise<UnifiedDashboardResponse> {
  const { data } = await apiAxios.get<UnifiedDashboardResponse>("/api/v1/analytics/dashboard", {
    params: { from, to },
  });
  return data;
}
